"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment SearchLink on Link {\n    title\n    relativeUrl\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.links = void 0;
var _fetching = require("@ori/fetching");
const links = exports.links = (0, _fetching.gql)(_templateObject());
